"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FooterContactItem_1 = __importDefault(require("./FooterContactItem"));
exports.default = FooterContactItem_1.default;
